import Vue from 'vue'
import * as mutation from '../mutation-types'
import Ws from '@adonisjs/websocket-client'

function isCurrentUser (userId, mutation) {
  if (!mutation.payload) console.warn('[studio/socket/chat] mutation has no payload', mutation)
  return mutation.payload && userId === mutation.payload.userId
}

function initChat (topic, store, userId, baseUrl) {
  topic.on('ready', () => {
    console.info('[studio/socket/chat] subscribed to topic chat:%s', userId)
    topic.emit('workspaceStateRequest', {userId})
    topic.emit('channelStateRequest', {channelId: 'program', userId})
    topic.emit('channelStateRequest', {channelId: 'preview', userId})
  })

  topic.on('error', (error) => {
    console.error('[studio/socket/chat] error', error)
  })

  topic.on('close', () => {
    console.info('[studio/socket/chat] close')
  })

  topic.on('workspaceStateResponse', function (payload) {
    console.debug('[studio/socket/chat] onWorkspaceStateResponse')
    // if (!isCurrentUser(payload)) return console.warn('[socket/chat] ignoring message not belonging to current user')
    store.commit(mutation.TEMPLATE_STATE, payload.templates)
    store.commit(mutation.ALBUM_STATE, {
      albums: payload.albums,
      pictures: payload.pictures.map(each => {
        each.image = baseUrl + each.imagePath
        return each
      })
    })
    store.commit(mutation.DATASET_STATE, payload.datasets)
    store.commit(mutation.WINDOW_STATE, payload.windows)
    store.commit(mutation.SOCKET_LOADED)
  })

  topic.on('channelStateResponse', function (payload) {
    console.debug('[studio/socket/chat] onChannelStateResponse')
    // if (!isCurrentUser(payload)) return console.warn('[socket/chat] ignoring message not belonging to current user')
    store.commit(mutation.CHANNEL_STATE, payload)
    store.commit(mutation.SOCKET_LOADED)
  })

  topic.on('mutation', function (mutation) {
    console.debug('[studio/socket/chat] onMutation, %s', mutation.type)
    if (!isCurrentUser(userId, mutation)) return console.warn('[socket/chat] ignoring message not belonging to current user')

    // Set remote flag to prevent echoing back to socket/server
    mutation.payload.remote = true

    // Commit mutation to local store
    store.commit(mutation.type, mutation.payload)
  })
}

function init (endpoint, store, userId, keycloak) {
  store.commit(mutation.SOCKET_LOADING, {number: 3})

  console.info('[studio/socket] connecting to ' + endpoint)
  const socket = Ws(endpoint)
  socket.connect()

  socket.on('open', ({connId}) => {
    console.info('[studio/socket] connected', connId)
    store.commit(mutation.SOCKET_CONNECTED)
    const baseUrl = (endpoint || '').replace(/ws(s)?:\/\//, 'http$1://')
    initChat(socket.subscribe('chat:' + userId), store, userId, baseUrl)
  })

  socket.on('error', (error) => {
    console.error('[studio/socket] error', error)
  })

  socket.on('close', () => {
    console.info('[studio/socket] disconnected')
    store.commit(mutation.SOCKET_DISCONNECTED)
  })

  store.subscribe(mutation => {
    if (mutation.payload && mutation.payload.emit) {
      // Don't reemit remote mutations
      if (!mutation.payload.remote) {
        // Add user id
        mutation.payload.userId = userId
        const chat = socket.getSubscription('chat:' + userId)
        if (chat) {
          if (keycloak && keycloak.updateToken) {
            keycloak.updateToken().then(function () {
              console.debug('[studio/socket/chat] emitting', mutation)
              chat.emit('mutation', mutation)
            }).catch(function () {
              console.error('[studio/socket/chat] failed to update keycloak token')
            })
          } else {
            console.debug('[studio/socket/chat] emitting', mutation)
            chat.emit('mutation', mutation)
          }
        } else {
          console.warn('[studio/socket/chat] no topic chat, are you offline?')
        }
      }
    }
  })
}

export default function webSocketPlugin () {
  return (store) => {
    // Quick hack to disable the websocket plugin in testing env
    if (Vue.prototype.$env.NODE_ENV === 'testing') return

    const vue = new Vue()
    vue.$nextTick(() => {
      const endpoint = Vue.prototype.$env.WEBCG_API

      const startSocket = (account) => {
        init(endpoint, store, account.accountId, vue.$keycloak)
      }

      if (store.getters.selectedAccount) {
        startSocket(store.getters.selectedAccount)
      } else {
        const unwatch = store.watch(
          state => state.selectedAccount,
          (selectedAccount) => {
            if (selectedAccount) {
              startSocket(selectedAccount)
              unwatch()
            }
          }
        )
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/plugins/webSocket.js